import type React from "react";
import { SHOP_INFO } from "../config";
import IssueCard from "./IssueCard";

const IssueSection: React.FC = () => {
  const issues = [
    {
      title: "肩こりがひどくて、首までつらい",
      description:
        "肩周りの緊張が強く、首までガチガチに。動かすと痛みや重だるさを感じ、日常生活にも支障が出てしまう…",
      recommendation: "もみほぐしコース",
      recommendationLink: "#menu-body",
      imageAlt: "肩こり",
      imageSrc: `${SHOP_INFO.basePath}/issue_shoulder.webp`,
    },
    {
      title: "足のむくみがひどく、夕方にはパンパン",
      description: "立ち仕事・座りっぱなし。足が重くて靴がきつく感じることも。",
      recommendation: "足つぼコース",
      recommendationLink: "#menu-foot",
      imageAlt: "足のむくみ",
      imageSrc: `${SHOP_INFO.basePath}/issue_legs.webp`,
    },
    {
      title: "眠りが浅くて、朝起きても疲れが取れない",
      description: "寝ても疲れがリセットされず、常に身体が重だるい状態が続く。",
      recommendation: "足つぼ + もみほぐし半々コース",
      recommendationLink: "#menu-set",
      imageAlt: "疲労",
      imageSrc: `${SHOP_INFO.basePath}/issue_fatigue.webp`,
    },
  ];

  return (
    <section
      id="recommend"
      className="pt-12 pb-16 md:pt-20 md:pb-24 bg-white relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] opacity-30"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10">
          <div className="inline-block relative">
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 leading-tight tracking-tight bg-white/80 backdrop-blur-sm p-4 rounded-xl border-2 border-gray-100 shadow-sm inline-block relative z-10">
              こんな
              <span className="text-[var(--temomi-red)] underline decoration-4 decoration-yellow-300 underline-offset-4 mx-2">
                お悩み
              </span>
              ありませんか？
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {issues.map((issue) => (
            <IssueCard
              key={issue.title}
              title={issue.title}
              description={issue.description}
              recommendation={issue.recommendation}
              recommendationLink={issue.recommendationLink}
              imageAlt={issue.imageAlt}
              imageSrc={issue.imageSrc}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IssueSection;
